export default "__VITE_ASSET__3ff7c8ff__"